import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'appSearch', standalone: true, })
export class AppSearchPipe implements PipeTransform {
  transform(allApps: any[], value) {
    if (value !== '') {
        return allApps.filter(app => {
            if (value !== undefined) {
                return (
                    app.name.toLowerCase().search(value.toLowerCase()) !== -1 ||
                    app.category.toLowerCase().search(value.toLowerCase()) !== -1 ||
                    app.url.toLowerCase().search(value.toLowerCase()) !== -1
                );
            }
            return false;
        });
    } else {
        return allApps;
    }
  }
}
